// extracted by mini-css-extract-plugin
export var descriptionDark = "o-nas-page-module--description-dark--3AYKg";
export var quoteWrapper = "o-nas-page-module--quote-wrapper--2pmTC";
export var quoteSpace = "o-nas-page-module--quote-space--g2liC";
export var quoteSpace__container = "o-nas-page-module--quote-space__container--Da0XC";
export var quotePhoto = "o-nas-page-module--quote-photo--1Oh-n";
export var quote = "o-nas-page-module--quote--3VoQQ";
export var quote__author = "o-nas-page-module--quote__author--1nGuO";